/* eslint-disable */
export const isObject = (input) => {
  if (typeof input === 'object') {
    if (!Array.isArray(input)) {
      return true;
    }
  }
  return false;
};
